// Default suggested price by rarity (admin can override per-sprite via API).
import { SPRITES } from '../mock';

export const PRICE_BY_RARITY = {
  rare: 2.5,
  epic: 5,
  legendary: 10,
  mythic: 25,
};

// Variant bumps a bit (Galaxy = +50%, Gummy = +20%, Holo = +30%)
export const PRICE_VARIANT_MULT = {
  base: 1,
  gold: 1.1,
  gummy: 1.2,
  galaxy: 1.5,
  holo: 1.3,
  special: 1.4,
};

export function defaultPrice(sprite) {
  const base = PRICE_BY_RARITY[sprite.rarity] ?? 5;
  const mult = PRICE_VARIANT_MULT[sprite.variant] ?? 1;
  return Math.round(base * mult * 100) / 100;
}

// Returns a map { spriteId -> {price, available} } merging defaults with the
// catalog overrides fetched from the backend.
export function buildPriceMap(catalogOverrides = []) {
  const map = {};
  SPRITES.forEach((s) => {
    map[s.id] = { price: defaultPrice(s), available: true, override: false };
  });
  catalogOverrides.forEach((o) => {
    if (map[o.sprite_id]) {
      map[o.sprite_id] = {
        price: o.suggested_price,
        available: o.available,
        override: true,
      };
    }
  });
  return map;
}
